import React from "react";
import { useNavigate } from "react-router-dom";
import { Styles } from "../styles.js";
import Button from "../../../components/shared/Button.jsx";
import BreadcrumbBox from "../../../components/common/Breadcrumb.jsx";
import { useLanguageDetector } from "../../../hooks/useLanguageDetector.js";
import EnglishData from "../../../data/summer-school/data.json";
import RussianData from "../../../data/summer-school/data-ru.json";
import UzbekData from "../../../data/summer-school/data-uz.json";
import Heading from "../../../components/shared/Heading.jsx";
import { Container } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { colors } from "../../../components/common/element/elements.js";
import { useTranslation } from "react-i18next";

const SummerScienceSpark = () => {
  const navigate = useNavigate();
  const [allData] = useLanguageDetector(EnglishData, RussianData, UzbekData);
  const data = allData?.spark;
  const { t } = useTranslation();

  return (
    <Styles>
      <BreadcrumbBox
        title={data?.title}
        image="/assets/images/summer-school-1.webp"
        preTitle={data?.preTitle}
        centerTitle={true}
        registerButton={true}
        registerLink="/summer-science-spark-form"
      />
      <Container>
        <section className="summer-school-section">
          <div className="subtitle">
            <p className="pb-2">{data?.paragraph1}</p>
            <p>{data?.paragraph2}</p>
          </div>

          <div className="aims">
            <Heading
              tag="h4"
              className="strategy-title"
              title={data?.aims?.title}
            />
            <ul className="list-unstyled">
              {data?.aims?.list.map((item, index) => (
                <li className="d-flex mb-3 item" key={index}>
                  <div>
                    <Icon
                      icon="ph:paper-plane-right-duotone"
                      fontSize={20}
                      color={colors.bg2}
                    />
                  </div>
                  <p className="ps-3">{item}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="details">
            <Heading
              tag="h4"
              className="strategy-title"
              title={data?.details?.title}
            />
            <div className="details-list">
              {data?.details?.list.map((item, index) => (
                <p className="item" key={index}>
                  <i>{item?.label}</i>{" "}
                  <span className={index === 7 ? "fw-bold" : "fw-normal"}>
                    {item?.value}
                  </span>
                </p>
              ))}
            </div>
          </div>

          <div className="syllabus">
            <Heading
              tag="h4"
              className="strategy-title"
              title={data?.syllabus?.title}
            />

            <div className="syllabus-data">
              {data?.syllabus?.tables?.map((table, index) => (
                <div key={index}>
                  <h5>
                    <b>{table?.title}</b> {table?.subtitle}
                  </h5>
                  <div>
                    <table className="table table-bordered w-100">
                      <thead>
                        <tr className="text-center">
                          <th scope="col">{t("Time")}</th>
                          <th scope="col">{t("Activity")}</th>
                          <th scope="col">{t("Details")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {table?.rows?.map((row, i) => (
                          <tr key={i}>
                            <td className="w-25">{row?.time}</td>
                            {row?.activity && (
                              <td
                                className="w-25"
                                rowSpan={index === 1 && i === 0 ? 2 : 1}
                                colSpan={index === 0 && i === 2 ? 2 : 1}
                              >
                                {row?.activity}
                              </td>
                            )}
                            {row?.details && (
                              <td
                                className="w-25"
                                rowSpan={
                                  (index === 1 && i === 0) ||
                                  (index === 3 && i === 0)
                                    ? 2
                                    : 1
                                }
                              >
                                {row?.details}
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="py-5 d-flex justify-content-center">
            <Button
              className={"apply-button"}
              text={"Register now"}
              onClick={() => navigate("/summer-science-spark-form")}
            ></Button>
          </div>
        </section>
      </Container>
    </Styles>
  );
};

export default SummerScienceSpark;
